export default {
  init() {
    // JavaScript to be fired on all pages

    $('#mainMenu').on('hidden.bs.collapse', function () {
      $('body').removeClass('menu-shown');
    });
    $('#mainMenu').on('show.bs.collapse', function () {
      $('body').addClass('menu-shown');
    });

    
    $(document).on('click','.carousel:not(#bg-carousel) .carousel-inner', function() {
      $(this).parents('.carousel').first().carousel("pause").carousel("next");
    });

    $('.form-wrap [name="your-country"]').on('change', function() {
      if($(this).val() === "Australia"){
        $('.form-wrap .project-state').removeClass('d-none');
      } else {
        $('.form-wrap .project-state').addClass('d-none');
      }
    });

    $('.form-wrap [name="your-project-type"]').on('change', function() {
      if($(this).val() === "Public Use"){
        $('.form-wrap .council-name-wrap').removeClass('d-none');
      } else {
        $('.form-wrap .council-name-wrap').addClass('d-none');
      }
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    if($('.project-previews .glider').length){
      if($(window).width() < 1000){
        $('.project-previews-wrap').insertAfter('.project-detail-wrap')
      }
      
      var glider = new Glider(document.querySelector('.glider'), {

        // `auto` allows automatic responsive
        // width calculations
        // slidesToShow: 'auto',
        // slidesToScroll: 'auto',
        slidesToShow: 2,
        slidesToScroll: 1,
        // should have been named `itemMinWidth`
        // slides grow to fit the container viewport
        // ignored unless `slidesToShow` is set to `auto`
        itemWidth: undefined,
      
        // if true, slides wont be resized to fit viewport
        // requires `itemWidth` to be set
        // * this may cause fractional slides
        exactWidth: false,
      
        // speed aggravator - higher is slower
        duration: .75,
      
        // dot container element or selector
        //dots: 'CSS Selector',
      
        // arrow container elements or selector
        arrows: {
          prev: '.prev-arrow',
          // may also pass element directly
          next: '.next-arrow'
        },
      
        // allow mouse dragging
        draggable: true,
        // how much to scroll with each mouse delta
        dragVelocity: 1.5,
      
        // use any custom easing function
        // compatible with most easing plugins
        easing: function (x, t, b, c, d) {
          return c*(t/=d)*t + b;
        },
      
        // event control
        scrollPropagate: false,
        eventPropagate: true,
      
        // Force centering slide after scroll event
        scrollLock: false,
        // how long to wait after scroll event before locking
        // if too low, it might interrupt normal scrolling
        scrollLockDelay: 150,
      
        // Force centering slide after resize event
        resizeLock: true,
      
        // Glider.js breakpoints are mobile-first
        responsive: [
          {
            breakpoint: 1250,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 4
            }
          },
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 3
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 450,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });


      if(glider && $('.project-previews .project-card.current').length){
        $(window).load(function() {
          var currentCard = $('.project-previews .project-card.current').first();
          var currentCardIndex = currentCard.attr('data-card-index');
          var addIndex = 0;
          if ($(window).width() > 450) {
            addIndex = -1;
          }
          if ($(window).width() > 1250) {
            addIndex = -2;
          }
          var scrollTo = (addIndex + currentCardIndex) * currentCard.outerWidth();
          glider.scrollTo(scrollTo);
          console.log('scroll to ',scrollTo);
        });
      }

    }


    if($('.faq-list .glider').length && $(window).width() > 576){
      
      var glider = new Glider(document.querySelector('.glider'), {

        // `auto` allows automatic responsive
        // width calculations
        // slidesToShow: 'auto',
        // slidesToScroll: 'auto',
        slidesToShow: 2,
        slidesToScroll: 1,
        // should have been named `itemMinWidth`
        // slides grow to fit the container viewport
        // ignored unless `slidesToShow` is set to `auto`
        itemWidth: undefined,
      
        // if true, slides wont be resized to fit viewport
        // requires `itemWidth` to be set
        // * this may cause fractional slides
        exactWidth: false,
      
        // speed aggravator - higher is slower
        duration: .75,
      
        // dot container element or selector
        //dots: 'CSS Selector',
      
        // arrow container elements or selector
        arrows: {
          prev: '.prev-arrow',
          // may also pass element directly
          next: '.next-arrow'
        },
      
        // allow mouse dragging
        draggable: true,
        // how much to scroll with each mouse delta
        dragVelocity: 1.5,
      
        // use any custom easing function
        // compatible with most easing plugins
        easing: function (x, t, b, c, d) {
          return c*(t/=d)*t + b;
        },
      
        // event control
        scrollPropagate: false,
        eventPropagate: true,
      
        // Force centering slide after scroll event
        scrollLock: false,
        // how long to wait after scroll event before locking
        // if too low, it might interrupt normal scrolling
        scrollLockDelay: 150,
      
        // Force centering slide after resize event
        resizeLock: true,
      
        // Glider.js breakpoints are mobile-first
        responsive: [
          {
            breakpoint: 1100,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }

    $(window).scroll(function() {
      if ( $('footer').is( ':in-viewport' ) ) {
        $('body').addClass('footer-in-viewport');
      } else{
        $('body').removeClass('footer-in-viewport');
      }
    });

    $("button").click(() => $(".carousel").carousel("next"));


    ///adjust menu current

    if($('article.category-projects').length){
      $('.menu-item-30').addClass('current-menu-item');
    }

    
    $('.values-wrap .col-value h3').matchHeight({
      byRow: true
    });

    $('.project-card .card-body').matchHeight();
    

    //contact form

    document.addEventListener( 'wpcf7mailsent', function( event ) {
      $('#formIntro').hide();
    }, false );

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js